/* May Designs sticky Add to Cart. Rebuilt 2026-09-29.
   Shows a bottom bar whenever the real Add to Cart is off screen. The bar's button
   clicks the real Add to Cart, so the personalization guard and gift card checks still run.
   Customily swaps the Add to Cart node after load, so the button is re-resolved on a tick
   (150ms for the first 12s, then every second) instead of observing one node. */
(function () {
  var form = document.querySelector('form[data-product-form]');
  if (!form) return;

  var PLACEHOLDERS = ['your name here', 'your text here', 'your monogram here', 'your phrase here', 'type here', 'enter name'];
  var bar, nameEl, metaEl, priceEl, btnEl, shown = false;

  function realButton() {
    var c = document.getElementById('customily-cart-btn');
    if (c && c.offsetParent) return c;
    var list = Array.prototype.slice.call(document.querySelectorAll('form[data-product-form] [name="add"]'));
    for (var i = 0; i < list.length; i++) { if (list[i].offsetParent) return list[i]; }
    return null;
  }

  function productName() {
    var h = document.querySelector('.product__title, h1');
    return h ? h.textContent.trim() : document.title.split('–')[0].trim();
  }

  /* The product price above the options is the one Customily updates for paid
     add-ons (Upload a Logo +$5 and similar), so it is the source of truth. The
     Add to Cart button only knows the variant price, so it is synced to match. */
  function pagePrice() {
    var list = Array.prototype.slice.call(document.querySelectorAll('.product__price [data-product-price], [data-product-price]'));
    for (var i = 0; i < list.length; i++) {
      var t = (list[i].textContent || '').replace(/\s/g, '');
      if (list[i].offsetParent && /\$[\d,]+/.test(t)) return t;
    }
    return '';
  }

  function priceFrom(btn) {
    var page = pagePrice();
    if (page) return page;
    var p = btn && btn.querySelector('[data-button-price]');
    if (p && p.textContent.trim()) return p.textContent.trim();
    var m = btn && (btn.textContent || '').match(/\$\s?[\d,]+(\.\d{2})?/);
    return m ? m[0].replace(/\s/g, '') : '';
  }

  function syncButtonPrice(btn) {
    var page = pagePrice();
    if (!btn || !page) return;
    var span = btn.querySelector('[data-button-price]');
    if (span && span.textContent.replace(/\s/g, '') !== page) span.textContent = page;
  }

  function checkedValue(label) {
    var el = form.querySelector('input[type="radio"][name="options[' + label + ']"]:checked') ||
             form.querySelector('select[name="options[' + label + ']"]');
    return el ? (el.value || '').trim() : '';
  }

  function personalText() {
    var f = Array.prototype.slice.call(form.querySelectorAll('textarea[name^="properties["], input[type="text"][name^="properties["]'))
      .filter(function (i) { return !!i.offsetParent; });
    var vals = [];
    f.forEach(function (i) {
      var v = (i.value || '').trim();
      if (v && PLACEHOLDERS.indexOf(v.toLowerCase()) === -1) vals.push(v.replace(/\s+/g, ' '));
    });
    return vals.join(' / ');
  }

  function meta() {
    var parts = [];
    var pages = checkedValue('Select your inside pages');
    if (pages) parts.push(pages);
    var pers = checkedValue('Personalize this product?');
    if (/^yes/i.test(pers)) {
      var t = personalText();
      parts.push(t ? 'Personalized: “' + t + '”' : 'Personalized: add your text');
    } else if (/^no/i.test(pers)) {
      parts.push('Not personalized');
    }
    return parts.join(' · ');
  }

  function build() {
    bar = document.createElement('div');
    bar.className = 'md-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="md-sticky-atc__inner">' +
      '<div class="md-sticky-atc__info"><div class="md-sticky-atc__name"></div><div class="md-sticky-atc__meta"></div></div>' +
      '<div class="md-sticky-atc__price"></div>' +
      '<button type="button" class="md-sticky-atc__btn">Add to Cart</button></div>';
    nameEl = bar.querySelector('.md-sticky-atc__name');
    metaEl = bar.querySelector('.md-sticky-atc__meta');
    priceEl = bar.querySelector('.md-sticky-atc__price');
    btnEl = bar.querySelector('.md-sticky-atc__btn');
    btnEl.addEventListener('click', function (e) {
      e.preventDefault();
      var b = realButton();
      if (b && !b.disabled) b.click();
    });
    document.body.appendChild(bar);
  }

  function update() {
    if (!bar) build();
    var b = realButton();
    var off = false;
    if (b) {
      var r = b.getBoundingClientRect();
      off = r.top > window.innerHeight || r.bottom < 0;
    }
    nameEl.textContent = productName();
    metaEl.textContent = meta();
    syncButtonPrice(b);
    priceEl.textContent = priceFrom(b);
    btnEl.disabled = !b || !!b.disabled;
    btnEl.textContent = b && b.disabled ? 'Sold Out' : 'Add to Cart';
    if (off !== shown) {
      shown = off;
      bar.classList.toggle('is-visible', off);
      bar.setAttribute('aria-hidden', off ? 'false' : 'true');
      document.body.style.paddingBottom = off ? (bar.offsetHeight + 'px') : '';
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; update(); });
  }

  function start() {
    update();
    var t0 = Date.now();
    var fast = setInterval(function () {
      update();
      if (Date.now() - t0 > 12000) {
        clearInterval(fast);
        setInterval(update, 1000);
      }
    }, 150);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
